import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

/**
 * @description
 * 
 * This module manages the state of the sales cart: the list of products
 * to be processed in a single transaction.
 */
const AuthModule = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
}

export default AuthModule
